import * as React from "react"
const Arrowsvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      enableBackground: "new 0 0 512 512",
    }}
    viewBox="0 0 512 512"
    {...props}
  >
    <path d="M307.2 51.2 271.4 87l143.4 143.4H0v51.2h414.7L271.4 425l35.8 35.8L512 256 307.2 51.2z" />
  </svg>
)
export default Arrowsvg
